import { h, Fragment } from 'preact';

import { ratings } from '../../../data/ratings';
import { testimonials } from '../../../data/testimonials';

import PaymentPlans from '../../shared/PaymentPlans';
import Testimonials from '../../shared/Testimonials';

import ComparePlans from './ComparePlans';
import Footnotes from '../../shared/Footnotes';

const Plans = () => (
    <Fragment>
        <div className="c-bg-shape--wave has-alt-dark-mode">
            <PaymentPlans className="is-hero u-flex-center" />
        </div>
        <ComparePlans />
        <Testimonials
            ratings={ratings}
            quotes={testimonials}
            className="c-bg-shape--wave-2 has-bottom"
        />
        <Footnotes />
    </Fragment>
);

export default Plans;
